/* The control that chooses a place by its name (a search of names, and "use my location"), shared by the report view's bar (rfhq_report_view.js) and by any list of an app's cards that sends a bar with it
   (rfhq_app_records.js: the card over a banner has the town it is about). It draws what an app's `lookup` control says (website_hq/report_toolbar.py): text is set as text, an address is a path on this
   site. A choice is kept in the visitor's browser under the control's name (localStorage rfhq:lookup:<name>, {value, label}), so that another page shows the same one. By default a choice goes to the
   page's own address (?<name>=<value>); a script that draws the control on a page that must not move says what to do instead (options.onChoose) and that the kept choice is not to be followed (options.keep false). */
(function () {
	"use strict";
	const UI = window.rfhqUI;
	if (!UI) return;

	const SVG = "http://www.w3.org/2000/svg";
	const ICONS = {
		date: "M3.5 5h17v15h-17zM3.5 10h17M8 3v4M16 3v4",
		pin: "M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21zM12 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
		near: "M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M12 2v3M12 19v3M2 12h3M19 12h3",
	};

	function icon(name) {
		const svg = document.createElementNS(SVG, "svg");
		svg.setAttribute("viewBox", "0 0 24 24"); svg.setAttribute("width", "16"); svg.setAttribute("height", "16"); svg.setAttribute("aria-hidden", "true"); svg.setAttribute("class", "rv-ctl-icon");
		const path = document.createElementNS(SVG, "path");
		path.setAttribute("d", ICONS[name]);
		svg.append(path);
		return svg;
	}

	const withArg = (arg, value) => { const url = new URL(window.location.href); url.searchParams.set(arg, value); return url.pathname + url.search; };
	const KEPT = "rfhq:lookup:";  // what the visitor chose, by the control's name, so that another page can show the same one (the card over the Home banner)
	function remember(arg, value, label) { try { localStorage.setItem(KEPT + arg, JSON.stringify({ value: String(value), label: label || "" })); } catch (e) { /* the browser keeps nothing: the page works without */ } }
	function remembered(arg) { try { return JSON.parse(localStorage.getItem(KEPT + arg) || "null"); } catch (e) { return null; } }

	/* What the visitor chose is kept in the browser, so that another page (the card over the Home banner) shows the same town. A page opened without a choice goes to the kept one, once in a visit. */
	function keep(c) {
		try {
			const query = new URLSearchParams(window.location.search);
			const kept = remembered(c.arg);
			if (query.has(c.arg)) {
				if (query.get(c.arg) === c.value) remember(c.arg, c.value, c.label);
				else if (kept && kept.value === query.get(c.arg)) localStorage.removeItem(KEPT + c.arg);  // (a town the page did not accept is not kept)
			} else {
				const once = KEPT + "went:" + window.location.pathname + ":" + c.arg;
				if (kept && kept.value && kept.value !== c.value && !sessionStorage.getItem(once)) { sessionStorage.setItem(once, "1"); window.location.replace(withArg(c.arg, kept.value)); }
			}
		} catch (e) { /* the browser keeps nothing: the page works without */ }
	}


	function lookupControl(c, UI, options) {
		options = options || {};
		const { h, call } = UI;
		const words = c.labels || {};
		let open = false, timer = null, results = [];
		const shown = c.label || words.choose || "";
		const town = h("button", { type: "button", class: "rv-ctl-btn rv-ctl-town", "aria-haspopup": "listbox", "aria-expanded": "false", "aria-label": (c.label && words.choose ? words.choose + ": " : "") + shown }, icon("pin"), h("span", { text: shown }), h("span", { class: "rv-ctl-caret", "aria-hidden": "true", text: "▾" }));
		const field = h("input", { type: "search", class: "rv-ctl-search", placeholder: words.search || "", "aria-label": words.search || "", autocomplete: "off" });
		const list = h("ul", { class: "rv-ctl-options", role: "listbox" });
		const none = h("p", { class: "rv-ctl-none", text: words.none || "", hidden: true });
		const box = h("div", { class: "rv-ctl-list", hidden: true }, field, list, none);
		const group = h("div", { class: "rv-ctl-group rv-ctl-place" }, town, box);

		function toggle(show) {
			open = show === undefined ? !open : show;
			box.hidden = !open;
			town.setAttribute("aria-expanded", open ? "true" : "false");
			if (open) { field.value = ""; list.replaceChildren(); none.hidden = true; field.focus(); }
		}
		function choose(id, label) { remember(c.arg, id, label); if (options.onChoose) options.onChoose(id, label); else window.location.assign(withArg(c.arg, id)); }
		function draw() {
			list.replaceChildren(...results.map((r) => {
				const item = h("li", { role: "option", tabindex: "-1" }, h("b", { text: r.name || "" }), h("span", { text: r.region || "" }));
				const label = (r.name || "") + (r.region ? ", " + String(r.region).split(",").pop().trim() : "");
				item.addEventListener("click", () => choose(r.id, label));
				item.addEventListener("keydown", (event) => {
					if (event.key === "Enter") choose(r.id, label);
					else if (event.key === "ArrowDown") { event.preventDefault(); (item.nextElementSibling || item).focus(); }
					else if (event.key === "ArrowUp") { event.preventDefault(); (item.previousElementSibling || field).focus(); }
					else if (event.key === "Escape") { toggle(false); town.focus(); }
				});
				return item;
			}));
			none.hidden = results.length > 0 || field.value.trim().length < 2;
		}
		town.addEventListener("click", () => toggle());
		field.addEventListener("input", () => {
			clearTimeout(timer);
			const text = field.value.trim();
			if (text.length < 2) { results = []; draw(); return; }
			timer = setTimeout(async () => {
				const answer = await call(c.search, { text });
				if (field.value.trim() !== text) return;  // the visitor has typed on since
				results = answer.ok && Array.isArray(answer.data) ? answer.data : [];
				draw();
			}, 220);
		});
		field.addEventListener("keydown", (event) => {
			if (event.key === "Escape") { toggle(false); town.focus(); }
			else if (event.key === "ArrowDown" && list.firstElementChild) { event.preventDefault(); list.firstElementChild.focus(); }
			else if (event.key === "Enter" && results.length) choose(results[0].id, results[0].name || "");
		});
		document.addEventListener("click", (event) => { if (open && !group.contains(event.target)) toggle(false); });
		if (c.near && navigator.geolocation) {
			const near = h("button", { type: "button", class: "rv-ctl-btn rv-ctl-near" }, icon("near"), h("span", { text: words.near || "" }));
			near.addEventListener("click", () => navigator.geolocation.getCurrentPosition(async (position) => {
				const answer = await call(c.near, { latitude: position.coords.latitude, longitude: position.coords.longitude });
				if (answer.ok && answer.data && answer.data.id) choose(answer.data.id, answer.data.label);  // (the position is used for this one answer and is not kept)
			}, () => {}, { maximumAge: 600000, timeout: 8000 }));
			group.append(near);
		}
		if (options.keep !== false) keep(c);
		return group;
	}


	Object.assign(UI, { lookupControl, icon, withArg });
})();
